import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import './styles.css';
import { App } from './app/app';

const detectWindowsOS = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isWindows =
    userAgent.includes('windows') || userAgent.includes('win32');

  if (isWindows) {
    document.documentElement.classList.add('windows');
  }
};

// Must run before React's first paint: `styles.css` keys the custom scrollbar
// off the `.windows` class on <html>, so adding it after mount would flash the
// native scrollbar on the first frame.
detectWindowsOS();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
);
